import React, { useState } from "react";
import { Modal, message } from "antd";
import TableAction from "../../components/TableAction";
import WithAuth from "../../hoc/WithAuth";
import CreateUserModal from "../../components/modals/CreateUserModal";
import UsersTable from "../../components/tables/users/UsersTable";

function UsersPage() {
  const [open, setOpen] = useState(false);

  const closeModal = () => {
    setOpen(false);
  };

  return (
    <div className="rounded-xl md:px-[50px] md:mt-[25px] md:pt-[22px] bg-transparent md:bg-white">
      <CreateUserModal open={open} hideModal={closeModal} />
      {/* <div className='hidden md:flex' style={{ alignItems: 'center', height: 80, backgroundColor: '#EEF3F8', borderRadius: 8.4, marginBottom: 12 }}>
                <TableAction setSearchText={setSearchText} onCreateNew={handleCreate} />
            </div> */}
      <UsersTable />
    </div>
  );
}

export default WithAuth(UsersPage);
